import Icon from "@material-ui/core/es/Icon/Icon";
import React from "react";
import VLButton from "./VLButton";

export const IconButton = (props) => {

    const newProps = {...props};

    newProps.style = {
        ...newProps.style,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        color: "white"
    };

    if (props.title === undefined) {
        newProps.title = (
            <>
                <Icon className={props.iconClass} fontSize="large">{props.icon}</Icon>
            </>
        );
    } else {
        newProps.title = (
            <>
                <Icon className={props.iconClass} fontSize="large">{props.icon}</Icon>
                <p>{props.title}</p>
                <p/>
            </>
        );
    }


    return <VLButton {...newProps}/>;
};


export const CompactIconButton = (props) => {

    const newProps = {...props};

    newProps.style = {
        ...newProps.style,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        color: "white"
    };

    newProps.title = (
        <>
            <Icon className={props.iconClass} fontSize="small">{props.icon}</Icon>
            {props.title && <p>{props.title}</p>}
        </>
    );

    return <VLButton {...newProps}/>;
};
